<button
	*ngIf="mode !== SIGNUPMODES.GUEST_REVIEW"
	type="button"
	class="ficon-arrow-left back-btn"
	role="button"
	[attr.aria-label]="'common_back' | translate"
	(click)="onBack$.next(null)"
	[disabled]="submitting$ | async">
</button>

<section [formGroup]="form" #content [class.student-signup]="!requiresAccountInfo">
	<h1 translate="sign-up-account-create-title"></h1>

	<ng-container *ngIf="infoKey">
		<mat-form-field appearance="outline" class="half">
			<mat-label translate="sign-up-form-label-first-name"></mat-label>
			<input matInput formControlName="firstName" maxlength="255" data-cy="account-create-form-firstname" />

			<mat-error
				*ngIf="form.controls.firstName.hasError('required') || form.controls.firstName.hasError('whitespace')"
				translate="sign-up-form-validation-first-name-required"
				data-cy="account-create-form-firstname-required">
			</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline" class="half">
			<mat-label translate="sign-up-form-label-last_name"></mat-label>
			<input matInput formControlName="lastName" maxlength="255" data-cy="account-create-form-lastname" />

			<mat-error
				*ngIf="form.controls.lastName.hasError('required') || form.controls.lastName.hasError('whitespace')"
				translate="sign-up-form-validation-last-name-required"
				data-cy="account-create-form-lastname-required">
			</mat-error>
		</mat-form-field>
	</ng-container>

	<mat-form-field appearance="outline" *ngIf="requiresAccountInfo">
		<mat-label translate="sign-up-form-label-phone-number"></mat-label>
		<input matInput formControlName="phoneNumber" maxlength="25" data-cy="account-create-form-phone" class="fullstory-ignore" />
	</mat-form-field>

	<mat-form-field appearance="outline" *ngIf="requiresAccountInfo">
		<mat-label translate="account-setup-primary-use"></mat-label>
		<mat-select
			formControlName="useType"
			data-cy="account-create-form-course-type"
			[placeholder]="'account-setup_select_one_placeholder' | translate"
			disableOptionCentering
			panelClass="offsetPanel">
			<mat-option
				*ngFor="let type of useTypes$ | async; trackBy:'use_type_id'|trackByProp"
				[value]="type">
				{{ $any(type).name }}
			</mat-option>
		</mat-select>
		<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
		<mat-error
			*ngIf="form.controls.useType.hasError('required')"
			translate="account-setup-error-required-primary-use"
			data-cy="account-create-form-course-type-required">
		</mat-error>
	</mat-form-field>

	<mat-form-field appearance="outline" *ngIf="requiresAccountInfo">
		<mat-label translate="account-setup_your_role"></mat-label>
		<mat-select
			formControlName="jobRole"
			data-cy="account-create-form-role"
			[placeholder]="'account-setup_select_one_placeholder' | translate"
			disableOptionCentering
			panelClass="offsetPanel">
			<mat-option
				*ngFor="let role of jobRoles$ | async; trackBy: 'name' | trackByProp"
				[value]="role.name">
				{{ role.name }}
			</mat-option>
		</mat-select>
		<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
		<mat-error
			*ngIf="form.controls.jobRole.hasError('required')"
			translate="account-setup-error-required_role"
			data-cy="account-create-form-role-required">
		</mat-error>
	</mat-form-field>

	<button
		mat-flat-button
		color="warn"
		type="button"
		class="submit-btn"
		(click)="accountCreate$.next()"
		[disabled]="submitting$ | async"
		data-cy="account-create-form-create-btn"
		[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">
		{{
			((submitting$ | async) ?
				'sign-up-form-creating-account' :
				'common_create-account') | translate
		}}
	</button>

	<mat-error
		*ngIf="errorMessage$ | async as errorKey"
		[translate]="errorKey"
		(click)="resolveError(errorKey)">
	</mat-error>
</section>
